import classNames from "classnames";

export const wrapper = classNames(
    // Mobile
    "mobile:px-12",
    "mobile:",
    // Tablet
    "tablet:px-28",
    // All
    "py-8",
    "relative"
)

export const heading = classNames(
    // Mobile
    "mobile:text-[20px]",
    // Tablet
    "tablet:text-[40px]",
    // All
)

export const border = classNames(
    // Mobile
    "mobile:w-[88%]",
    // Tablet
    "tablet:w-[46%]",
    // All
    "absolute",
    "-left-4",
    "border-t-2",
    "border-[#04A9F4]",
)

export const mHealthDescription = classNames(
    // Mobile
    "mobile:py-4",
    "mobile:text-[12px]",
    // Tablet
    "tablet:py-2",
    "tablet:text-[18px]",
    // All
    "font-thin",
)

export const infoGraphic = classNames(
    // Mobile
    "mobile:px-0",
    "mobile:mt-0",
    // Tablet
    "tablet:px-16",
    "tablet:mt-2",
    // All
    "mb-8",
    "mx-auto",
)


